import State from 'store/State';
import { useSelector } from 'react-redux';
import { selectWidgetComponentState } from 'widgets/store/component/selectors';
import {
    initialStrategyParametersComponentState,
    StrategyParametersComponentState,
} from 'widgets/strategyParams/store/component/StrategyParametersComponentState';
import { WidgetType } from 'widgets/WidgetType';
import { useWidgetContext } from 'widgets/WidgetContext';

export const useSelectQuickSearchText = () => {
    const { widgetKey } = useWidgetContext();
    return useSelector(
        (state: State) =>
            (
                selectWidgetComponentState<StrategyParametersComponentState>(
                    state,
                    WidgetType.STRATEGY_PARAMETERS,
                    widgetKey
                ) ?? initialStrategyParametersComponentState
            ).quickSearchText
    );
};
